import { observable, action, makeObservable } from 'mobx'

export const LIQUIDATION_STATUS = {
    UNAVAILABLE: "unavailable",     // No disponible
    PENDING: "pending",             // Factura pendiente
    INVOICED: "invoiced",           // Facturado
    PAID: "paid",                   // Pagado
    INVOICE_REJECTED: "rejected",   // Corregir factura
}

class CurrentAccount {
    constructor() {
        this.id = null
        this.liquidations = null

        makeObservable(this, {
            // observables
            id: observable,
            liquidations: observable,

            // actions
            setCurrentAccount: action,
        })
    }

    setCurrentAccount(value) {
        this.liquidations = value
    }
}

export default CurrentAccount
